import {setMedia, setSection} from '../slices/statusSlice';

export const finalizedMiddleware = store => next => action => {
    const result = next(action);
	if (action.type === 'configuration/finalizeConfiguration/fulfilled') {
		console.log('finalizedMiddleware finalizeConfiguration fulfilled');
		const state = store.getState();

		// show finalize section
		store.dispatch(setSection({currentSection: 'finalize'}));
		store.dispatch(setMedia({media: 'sections'}));
    }

	if (action.type === 'configuration/configurationLoading/fulfilled') {
		const state = store.getState();

		if (state.configuration.data.finalized && state.status.media !== 'print' && state.status.media !== 'print2') {
			store.dispatch(setSection({currentSection: 'finalize'}));
			store.dispatch(setMedia({media: 'sections'}));
		}
	}
    return result;
};
